/** Shared orders list page size (POS `start`/`size` → BOP). Keep free of store imports. */
export const ORDERS_PAGE_SIZE = 200;
